import React, { useEffect } from "react";
import TagManager from "react-gtm-module";

const tagManagerArgs = {
    gtmId: 'GTM-WZBG674'
  }
  
  TagManager.initialize(tagManagerArgs)

function Form() {
    useEffect(() => {
        (function () {
            
            var C = {
                BasePath: "https://smc-lp.s4hana.ondemand.com/na/elastic-access/sap/lpi/",
                ResultHeadersPath: "",
                CORS: true,
                CSRFTokenHeader: "",
                AppendScenarioParameter: "_L54AD1F204_",
                Tenant: "https://my313564.s4hana.ondemand.com/",
                Version: "22.0.4",
            };
            var R = {
                getConfig: function (c) {
                    if (c) {
                        var b = R.Setting.get(c, "lpi-base-path"),
                            t = R.Setting.get(c, "lpi-tenant");
                        if (b && t) {
                            return { BasePath: b, ResultHeadersPath: "", CORS: true, CSRFTokenHeader: "", AppendScenarioParameter: "_L54AD1F204_", Tenant: t, Version: C.Version };
                        }
                    }
                    return C;
                },
                initialize: function () {
                    if (this.isInitializing() || this.isInitialized()) {
                        return;
                    }
                    this.reset();
                    var c = this.getPages(),
                        i;
                    for (i = 0; i < c.length; i++) {
                        this.ContentPage.prepare(c[i]);
                    }
                    this.Request.fetchToken(c, this.handleFetchTokenResponse.bind(this));
                },
                handleFetchTokenResponse: function (c, s) {
                    var i;
                    if (s) {
                        for (i = 0; i < c.length; i++) {
                            this.Result.sendOpen(c[i], this.handleOpenResponse.bind(this));
                        }
                    } else {
                        for (i = 0; i < c.length; i++) {
                            R.ContentPage.toggleErrorMessage(c[i], true);
                        }
                    }
                },
                handleOpenResponse: function (c, r) {
                    if (R.Request.isErrorResponse(r)) {
                        R.ContentPage.toggleErrorMessage(c, true);
                    } else {
                        this.ContentPage.finishLoading(c, r);
                    }
                    c.sapCpInitializing = false;
                    c.sapCpInitialized = true;
                },
                isInitializing: function () {
                    var c = this.getPages(),
                        i;
                    for (i = 0; i < c.length; i++) {
                        if (c[i].sapCpInitializing) {
                            return true;
                        }
                    }
                    return false;
                },
                isInitialized: function () {
                    var c = this.getPages(),
                        i;
                    for (i = 0; i < c.length; i++) {
                        if (!c[i].sapCpInitialized) {
                            return false;
                        }
                    }
                    return true;
                },
                getPages: function () {
                    return R.Node.getAllWithClassName(document, "sapCpContentPage");
                },
                reset: function () {
                    var c = this.getPages(),
                        i,
                        o;
                    for (i = 0; i < c.length; i++) {
                        o = c[i];
                        delete o.sapCpInitializing;
                        delete o.sapCpInitialized;
                        delete o.sapCpCSRFToken;
                    }
                },
                ContentPage: {
                    prepare: function (c) {
                        if (c.sapCpInitializing || c.sapCpInitialized) {
                            return;
                        }
                        c.sapCpInitializing = true;
                        this.checkVersion(c);
                        this.prepareWidgets(c);
                        this.appendOutboundIdToLinks(c);
                        R.Event.registerListener(c, "submit", this.handleSubmitEvent.bind(this));
                    },
                    checkVersion: function (c) {
                        var s = R.Setting.get(c, "version"),
                            m = R.getConfig(c);
                        if (s > m.Version) {
                            R.Console.warn("You are using an outdated version of the landing page script");
                        }
                    },
                    prepareWidgets: function (c) {
                        var w = this.getWidgets(c),
                            i;
                        for (i = 0; i < w.length; i++) {
                            R.Widget.prepare(w[i]);
                        }
                    },
                    getWidgets: function (c) {
                        return R.Node.getAllWithClassName(c, "sapCpWidget");
                    },
                    findSurroundingLandingPageOrReturnForm: function (c) {
                        return R.Util.findParentByClassName(c, "sapLandingPage") || c;
                    },
                    appendOutboundIdToLinks: function (c) {
                        var o = R.Util.getOutboundId();
                        if (!o) {
                            return;
                        }
                        var r = R.ContentPage.findSurroundingLandingPageOrReturnForm(c),
                            l = r.getElementsByTagName("a"),
                            i;
                        for (i = 0; i < l.length; i++) {
                            l[i].href = R.Util.appendOutboundId(l[i].href, o);
                        }
                    },
                    checkMissingMandatoryFieldsLabel: function (n) {
                        var c = R.Util.findParentByClassName(n, "sapCpContentPage"),
                            m = R.Node.getAllWithClassName(c, "sapCpWidgetMandatoryMissing"),
                            h = m.length > 0;
                        R.ContentPage.toggleMissingMandatoryField(c, h);
                    },
                    finishLoading: function (c, r) {
                        if (r && r.ContactPersonalizationData && r.ContactPersonalizationData.results) {
                            this.processPersonalizationData(c, r.ContactPersonalizationData.results);
                        }
                        this.processDataAndPrepareProgresProfileWidget(c);
                        this.toggleLoading(c, false);
                    },
                    processPersonalizationData: function (c, p) {
                        var P,
                            w = this.getWidgets(c),
                            W,
                            i;
                        for (i = 0; i < p.length; i++) {
                            P = p[i];
                            W = R.Util.findWidgetByKey(w, P.WidgetKeyHash);
                            if (W) {
                                R.Widget.applyPersonalization(W, P.Value);
                            }
                        }
                    },
                    processDataAndPrepareProgresProfileWidget: function (c) {
                        var w = this.getWidgets(c),
                            i,
                            W,
                            m = R.Setting.get(c, "progres-max"),
                            M = parseInt(m, 10);
                        if (R.Setting.get(c, "prefill-data") !== "true") {
                            return;
                        }
                        if (R.Setting.get(c, "progres-enabled") !== "true") {
                            return;
                        }
                        var p = [];
                        for (i = 0; i < w.length; i++) {
                            W = R.Widget.addProgressiveEnabledWidgets(w[i]);
                            if (W !== null && W !== undefined) {
                                p.push(W);
                            }
                        }
                        p.sort(function (a, b) {
                            return a.widgetPrio - b.widgetPrio;
                        });
                        for (var I = 0; I < M && I < p.length; I++) {
                            if (R.CSS.hasClass(p[I].widget, "sapCpWidgetMandatory")) {
                                if (R.Node.getFirstWithClassName(p[I].widget, "sapCpInput")) {
                                    R.Node.getFirstWithClassName(p[I].widget, "sapCpInput").setAttribute("required", "required");
                                }
                                if (R.Node.getFirstWithClassName(p[I].widget, "sapCpDropDown")) {
                                    Array.from(R.Node.getAllWithClassName(p[I].widget, "sapCpDropDown")).forEach(function (s) {
                                        s.setAttribute("required", "required");
                                    });
                                }
                                if (R.Node.getFirstWithClassName(p[I].widget, "sapCpCheckBox")) {
                                    R.Node.getFirstWithClassName(p[I].widget, "sapCpCheckBox").setAttribute("required", "required");
                                }
                            }
                            R.CSS.toggleClass(p[I].widget, "sapCpWidgetHidden", false);
                        }
                    },
                    handleSubmitEvent: function (e) {
                        if (e.preventDefault) {
                            e.preventDefault();
                        }
                    },
                    collectAnswers: function (c, o, f) {
                        var w = this.getWidgets(c),
                            W,
                            a = [],
                            i = 0,
                            m = false,
                            I = false,
                            b;
                        for (b = 0; b < w.length; b++) {
                            W = w[b];
                            R.Widget.collectAnswer(W, o, function (A) {
                                if (A) {
                                    a.push(A);
                                } else if (A === false && !R.CSS.hasClass(W, "sapCpWidgetHidden")) {
                                    m = true;
                                } else if (A === null) {
                                    I = true;
                                }
                                i++;
                                if (i === w.length) {
                                    if (m || I) {
                                        f(false);
                                    } else {
                                        f(a);
                                    }
                                }
                            });
                        }
                    },
                    toggleLoading: function (c, s) {
                        R.CSS.toggleClass(c, "sapCpContentPageLoading", s);
                    },
                    toggleMissingMandatoryField: function (c, s) {
                        R.CSS.toggleClass(c, "sapCpMissingMandatoryField", s);
                    },
                    toggleInvalid: function (c, i) {
                        R.CSS.toggleClass(c, "sapCpContentPageInvalid", i);
                    },
                    toggleErrorMessage: function (c, s) {
                        R.CSS.toggleClass(c, "sapCpSubmitError", s);
                    },
                    toggleSuccessMessage: function (c, s) {
                        R.CSS.toggleClass(c, "sapCpSubmitCompleted", s);
                    },
                    isProductiveTestMode: function (c) {
                        var t = R.Setting.get(c, "test-mode"),
                            p = R.Setting.get(c, "productive");
                        return t && p;
                    },
                    setErrorMessage: function (c, e) {
                        var E = R.Node.getFirstWithClassName(c, "sapCpErrorMessageText");
                        if (E) {
                            E.sapCpErrorMessage = E.sapCpErrorMessage || E.textContent;
                            E.textContent = e || E.sapCpErrorMessage;
                        }
                    },
                },
                Layout: {},
                Widget: {
                    prepare: function (w) {
                        if (this.isInputWidget(w)) {
                            R.InputWidget.prepare(w);
                        } else if (this.isCheckBoxWidget(w)) {
                            R.CheckBoxWidget.prepare(w);
                        } else if (this.isDownloadWidget(w)) {
                            R.DownloadWidget.prepare(w);
                        } else if (this.isButtonWidget(w)) {
                            R.ButtonWidget.prepare(w);
                        } else if (this.isInteractionWidget(w)) {
                            R.InteractionWidget.prepare(w);
                        }
                    },
                    applyPersonalization: function (w, v) {
                        if (this.isInputWidget(w)) {
                            R.InputWidget.applyPersonalization(w, v);
                        } else if (this.isCheckBoxWidget(w)) {
                            R.CheckBoxWidget.applyPersonalization(w, v);
                        }
                    },
                    collectAnswer: function (w, c, f) {
                        var h = function (a) {
                            if (a === false) {
                                R.Widget.toggleMissingMandatory(w, true);
                                R.Widget.toggleInvalid(w, false);
                            } else if (a === null) {
                                R.Widget.toggleMissingMandatory(w, false);
                                R.Widget.toggleInvalid(w, true);
                            } else {
                                R.Widget.toggleMissingMandatory(w, false);
                                R.Widget.toggleInvalid(w, false);
                            }
                            f(a);
                        };
                        if (this.isTextWidget(w)) {
                            f();
                        } else if (this.isInputWidget(w)) {
                            R.InputWidget.collectAnswer(w, h);
                        } else if (this.isNoteWidget(w)) {
                            R.NoteWidget.collectAnswer(w, h);
                        } else if (this.isCheckBoxWidget(w)) {
                            R.CheckBoxWidget.collectAnswer(w, h);
                        } else if (this.isDownloadWidget(w)) {
                            R.DownloadWidget.collectAnswer(w, h);
                        } else if (this.isButtonWidget(w)) {
                            R.ButtonWidget.collectAnswer(w, c, h);
                        } else if (this.isInteractionWidget(w)) {
                            R.InteractionWidget.collectAnswer(w, h);
                        } else if (this.isCaptchaWidget(w)) {
                            R.CaptchaWidget.collectAnswer(w, h);
                        }
                    },
                    addProgressiveEnabledWidgets: function (w) {
                        var W = w;
                        if (!this.isInputWidget(w)) {
                            return null;
                        }
                        if (R.Setting.get(W, "wProgres-enabled") === "false") {
                            return null;
                        }
                        var i = R.Node.getFirstWithClassName(W, "sapCpInput");
                        if (R.Node.getFirstWithClassName(W, "sapCpDropDown")) {
                            i = R.Node.getFirstWithClassName(W, "sapCpDropDown");
                        }
                        if (R.Node.getFirstWithClassName(W, "sapCpCheckBox")) {
                            i = R.Node.getFirstWithClassName(W, "sapCpCheckBox");
                        }
                        if (i && !i.value) {
                            return { widgetPrio: R.Setting.get(W, "wProgres-prio"), widget: W };
                        }
                        return null;
                    },
                    isMandatory: function (w) {
                        return R.CSS.hasClass(w, "sapCpWidgetMandatory");
                    },
                    isTextWidget: function (w) {
                        return R.CSS.hasClass(w, "sapCpTextWidget");
                    },
                    isInputWidget: function (w) {
                        return R.CSS.hasClass(w, "sapCpInputWidget");
                    },
                    isNoteWidget: function (w) {
                        return R.CSS.hasClass(w, "sapCpNoteWidget");
                    },
                    isCheckBoxWidget: function (w) {
                        return R.CSS.hasClass(w, "sapCpCheckBoxWidget");
                    },
                    isDownloadWidget: function (w) {
                        return R.CSS.hasClass(w, "sapCpDownloadWidget");
                    },
                    isButtonWidget: function (w) {
                        return R.CSS.hasClass(w, "sapCpButtonWidget");
                    },
                    isInteractionWidget: function (w) {
                        return R.CSS.hasClass(w, "sapCpInteractionWidget");
                    },
                    isCaptchaWidget: function (w) {
                        return R.CSS.hasClass(w, "sapCpCaptchaWidget");
                    },
                    toggleMissingMandatory: function (w, m) {
                        R.CSS.toggleClass(w, "sapCpWidgetMandatoryMissing", m);
                    },
                    toggleInvalid: function (w, i) {
                        R.CSS.toggleClass(w, "sapCpWidgetInvalid", i);
                    },
                },
                InputWidget: {
                    prepare: function (i) {
                        var I = R.Widget.isMandatory(i),
                            a,
                            d,
                            D,
                            b;
                        d = i.getElementsByTagName("select");
                        for (b = 0; b < d.length; b++) {
                            R.Event.registerListener(d[b], "change", this.handleDropDownChangeEvent.bind(this));
                        }
                        D = R.Node.getFirstWithClassName(i, "sapCpDatePicker");
                        if (D) {
                            this.prepareDatePicker(D);
                        }
                        if (R.CSS.hasClass(i, "sapCpContactAttribute-COUNTRY")) {
                            this.prepareCountryNode(i);
                        }
                        if (R.CSS.hasClass(i, "sapCpContactAttribute-REGION")) {
                            this.prepareRegionNode(i);
                        }
                        if (R.Setting.get(i, "wProgres-enabled") === "true") {
                            R.CSS.toggleClass(i, "sapCpWidgetHidden", true);
                            if (R.CSS.hasClass(i, "sapCpWidgetMandatory")) {
                                if (R.Node.getFirstWithClassName(i, "sapCpInput")) {
                                    R.Node.getFirstWithClassName(i, "sapCpInput").removeAttribute("required");
                                }
                                if (R.Node.getFirstWithClassName(i, "sapCpDropDown")) {
                                    var s = R.Node.getAllWithClassName(i, "sapCpDropDown");
                                    Array.from(s).forEach(this.appendChildNodes);
                                }
                                if (R.Node.getFirstWithClassName(i, "sapCpCheckBox")) {
                                    R.Node.getFirstWithClassName(i, "sapCpCheckBox").removeAttribute("required");
                                }
                            }
                        }
                        if (!I) {
                            return;
                        }
                        a = i.getElementsByTagName("input");
                        if (a[0]) {
                            R.Event.registerListener(a[0], "focusout", this.handleInputFocusOutEvent.bind(this));
                        }
                    },
                    prepareDatePicker: function (d) {
                        var D = R.Node.getAllWithClassName(d, "sapCpDropDown"),
                            o,
                            i;
                        for (i = 0; i < D.length; i++) {
                            o = D[i];
                            if (R.CSS.hasClass(o, "sapCpDatePickerDay")) {
                                this.prepareDatePickerDayDropDown(o);
                            } else if (R.CSS.hasClass(o, "sapCpDatePickerMonth")) {
                                R.Event.registerListener(o, "change", this.handleDatePickerDropDownChangeEvent.bind(this));
                            } else if (R.CSS.hasClass(o, "sapCpDatePickerYear")) {
                                this.prepareDatePickerYearDropDown(o);
                                R.Event.registerListener(o, "change", this.handleDatePickerDropDownChangeEvent.bind(this));
                            }
                        }
                    },
                    prepareDatePickerDayDropDown: function (d) {
                        var i;
                        for (i = 1; i <= 31; i++) {
                            this.addDatePickerDropDownOption(d, i);
                        }
                    },
                    prepareDatePickerYearDropDown: function (y) {
                        var d = R.Setting.get(y, "dropdowntype"),
                            Y = d.split("-"),
                            i,
                            a,
                            c = new Date(),
                            b = c.getFullYear(),
                            e,
                            I;
                        if (Y.length === 4) {
                            i = parseInt(Y[2], 10) || 0;
                            a = parseInt(Y[3], 10) || 0;
                        }
                        if (i > 0) {
                            for (I = i; I > 0; I--) {
                                e = b + I;
                                this.addDatePickerDropDownOption(y, e);
                            }
                        }
                        this.addDatePickerDropDownOption(y, b);
                        if (a > 0) {
                            for (I = 1; I <= a; I++) {
                                e = b - I;
                                this.addDatePickerDropDownOption(y, e);
                            }
                        }
                    },
                    prepareCountryNode: function (c) {
                        R.Event.registerListener(c, "change", this.handleCountryDropDownChangeEvent.bind(this));
                    },
                    prepareRegionNode: function (r) {
                        var s = r.getElementsByTagName("select"),
                            i,
                            S;
                        for (i = 0; i < s.length; i++) {
                            S = this.findSelectedCountryCode(r);
                            if (S) {
                                this.updateRegionValues(s[i], S);
                                s[i].disabled = false;
                            } else {
                                s[i].disabled = true;
                            }
                        }
                    },
                    findSelectedCountryCode: function (n) {
                        var i,
                            c = R.Util.findSiblingNodeByClassName(n, "sapCpContactAttribute-COUNTRY"),
                            s = c.getElementsByTagName("select")[0],
                            S = s.options;
                        for (i = 0; i < S.length; i++) {
                            if (S[i].selected && S[i].value) {
                                return S[i].value;
                            }
                        }
                        return null;
                    },
                    applyPersonalization: function (i, v) {
                        var I = R.Node.getFirstWithClassName(i, "sapCpInput"),
                            c = R.Node.getFirstWithClassName(i, "sapCpCheckBox"),
                            d = R.Node.getFirstWithClassName(i, "sapCpDatePicker"),
                            D = R.Node.getFirstWithClassName(i, "sapCpDropDown"),
                            a;
                        if (!v) {
                            return;
                        }
                        if (I) {
                            I.value = v;
                        } else if (c) {
                            a = c.getElementsByTagName("input");
                            if (a[0]) {
                                a[0].checked = !!v;
                            }
                        } else if (d) {
                            if (v !== "00000000") {
                                var y = R.Node.getFirstWithClassName(d, "sapCpDatePickerYear"),
                                    m = R.Node.getFirstWithClassName(d, "sapCpDatePickerMonth"),
                                    o = R.Node.getFirstWithClassName(d, "sapCpDatePickerDay");
                                if (y) {
                                    y.value = v.substring(0, 4);
                                }
                                if (m) {
                                    m.value = v.substring(4, 6);
                                }
                                if (o) {
                                    o.value = v.substring(6, 8);
                                }
                            }
                        } else if (D) {
                            var b = D.parentElement.parentElement.classList.contains("sapCpContactAttribute-COUNTRY");
                            if (b) {
                                var r = R.Util.findSiblingNodeByClassName(D, "sapCpContactAttribute-REGION");
                            }
                            if (b && r) {
                                D.value = v;
                                this.updateDropDownValue(D);
                                this.prepareRegionNode(r);
                            } else {
                                D.value = v;
                                this.updateDropDownValue(D);
                            }
                        }
                    },
                    appendChildNodes: function (s) {
                        var S = R.Node.createEmptyOptionElement();
                        if (s.querySelectorAll("option[selected = 'selected']").length === 0) {
                            s.appendChild(S);
                        }
                        s.removeAttribute("required");
                    },
                    handleInputFocusOutEvent: function (e) {
                        var i = e.target,
                            I = R.Util.findParentByClassName(i, "sapCpInputWidget");
                        if (i.value) {
                            R.Widget.toggleMissingMandatory(I, false);
                        }
                        R.ContentPage.checkMissingMandatoryFieldsLabel(I);
                    },
                    handleDropDownChangeEvent: function (e) {
                        var d = e.target;
                        this.updateDropDownValue(d);
                    },
                    handleDatePickerDropDownChangeEvent: function (e) {
                        var d = e.target,
                            D = d.parentNode;
                        this.updateDatePickerValues(D);
                    },
                    handleCountryDropDownChangeEvent: function (e) {
                        var s = this.findSelectedCountryCode(e.srcElement),
                            r = R.Util.findSiblingNodeByClassName(e.srcElement, "sapCpContactAttribute-REGION"),
                            S;
                        if (r) {
                            S = r.getElementsByTagName("select")[0];
                            this.updateRegionValues(S, s);
                            S.disabled = !s;
                        }
                    },
                    createOptionElement: function (r) {
                        var o;
                        if (r) {
                            o = document.createElement("option");
                            o.label = r.label;
                            o.value = r.value;
                            o.selected = r.selected;
                            o.text = r.text;
                            return o;
                        }
                        return null;
                    },
                    updateRegionValues: function (s, S) {
                        var i, r, o;
                        if (!s.aBufferedRegions) {
                            s.aBufferedRegions = [];
                            for (i = 0; i < s.options.length; i++) {
                                o = s.options[i];
                                r = {};
                                r.label = o.label;
                                r.value = o.value;
                                r.selected = o.selected;
                                r.text = o.text;
                                s.aBufferedRegions.push(r);
                            }
                        }
                        s.innerHTML = "";
                        if (S) {
                            for (i = 0; i < s.aBufferedRegions.length; i++) {
                                r = s.aBufferedRegions[i];
                                if (r.value.indexOf(S) === 0 || !r.value) {
                                    if (r.selected && r.value) {
                                        r.selected = false;
                                    }
                                    if (!S && !r.value) {
                                        r.selected = true;
                                    } else {
                                        r.selected = false;
                                    }
                                    o = this.createOptionElement(r);
                                    s.add(o);
                                }
                            }
                        } else {
                            for (i = 0; i < s.aBufferedRegions.length; i++) {
                                r = s.aBufferedRegions[i];
                                if (!r.value) {
                                    o = this.createOptionElement(r);
                                    s.add(o);
                                }
                            }
                        }
                    },
                    updateDropDownValue: function (d) {
                        R.CSS.toggleClass(d, "sapCpDropDownPlaceholder", !d.value);
                    },
                    updateDatePickerValues: function (d) {
                        var D = R.Node.getFirstWithClassName(d, "sapCpDatePickerDay"),
                            m = R.Node.getFirstWithClassName(d, "sapCpDatePickerMonth"),
                            y = R.Node.getFirstWithClassName(d, "sapCpDatePickerYear");
                        if (!D || !m || !y) {
                            return;
                        }
                        var s = D.selectedOptions[0].value,
                            S = m.selectedOptions[0].value,
                            a = y.selectedOptions[0].value,
                            i = parseInt(s, 10) || 0,
                            b = parseInt(S, 10) || 0,
                            c = parseInt(a, 10) || 0,
                            o = new Date(c, b, 0),
                            e = o.getDate(),
                            O = D.options.length,
                            f,
                            I;
                        if (i > e) {
                            D.selectedIndex = e.toString();
                        }
                        if (O > e + 1) {
                            for (I = O; I > e + 1; I--) {
                                D.remove(I - 1);
                            }
                        } else if (O < e + 1) {
                            for (I = O; I < e + 1; I++) {
                                f = I;
                                this.addDatePickerDropDownOption(D, f);
                            }
                        }
                    },
                    addDatePickerDropDownOption: function (d, v) {
                        var V = v.toString(),
                            n;
                        if (v < 10) {
                            V = "0" + V;
                        }
                        n = new Option(V, V);
                        d.add(n);
                    },
                    checkValidity: function (i) {
                        var r;
                        var v = true;
                        var I = "";
                        if (i.type === "email") {
                            if (i.value) {
                                r = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
                                v = r.test(i.value);
                                if (!v) {
                                    I = i.getAttribute("data-sap-cp-validationMessage");
                                }
                            }
                        }
                        if (i.type === "tel") {
                            if (i.value) {
                                r = new RegExp("^\\+(?:[0-9] ?){6,28}[0-9]$");
                                v = r.test(i.value);
                                if (!v) {
                                    I = i.getAttribute("data-sap-cp-validationMessage");
                                }
                            }
                        }
                        if (i.setCustomValidity) {
                            i.setCustomValidity(I);
                            i.title = I;
                        } else {
                            i.title = I;
                        }
                        return v;
                    },
                    collectAnswer: function (i, c) {
                        var I = R.Widget.isMandatory(i),
                            o = R.Node.getFirstWithClassName(i, "sapCpInput"),
                            a = R.Node.getFirstWithClassName(i, "sapCpCheckBox"),
                            d = R.Node.getFirstWithClassName(i, "sapCpDatePicker"),
                            D = R.Node.getFirstWithClassName(i, "sapCpDropDown"),
                            b,
                            s,
                            e;
                        if (o) {
                            e = !this.checkValidity(o);
                            s = o.value;
                        } else if (a) {
                            b = a.getElementsByTagName("input");
                            if (b[0]) {
                                s = b[0].checked ? "X" : "";
                            }
                        } else if (d) {
                            var y = R.Node.getFirstWithClassName(d, "sapCpDatePickerYear"),
                                m = R.Node.getFirstWithClassName(d, "sapCpDatePickerMonth"),
                                f = R.Node.getFirstWithClassName(d, "sapCpDatePickerDay");
                            if (y && m && f) {
                                s = y.value + m.value + f.value;
                            }
                            if (!/^[0-9]{8}$/.test(s)) {
                                s = "";
                            }
                        } else if (D) {
                            s = D.value;
                        }
                        if (I && !s) {
                            c(false);
                        } else if (e) {
                            c(null);
                        } else {
                            var A = { WidgetKeyHash: R.Setting.get(i, "key"), WidgetValueKeyHash: "", Value: s };
                            c(A);
                        }
                    },
                },
                CheckBoxWidget: {
                    prepare: function (c) {
                        var i = R.Widget.isMandatory(c),
                            o;
                        if (!i) {
                            return;
                        }
                        o = c.getElementsByTagName("input")[0];
                        if (o) {
                            R.Event.registerListener(o, "focusout", this.handleCheckBoxFocusOutEvent.bind(this));
                        }
                    },
                    applyPersonalization: function (c, v) {
                        var o;
                        o = c.getElementsByTagName("input")[0];
                        if (o) {
                            o.checked = o.checked || !!v;
                        }
                    },
                    handleCheckBoxFocusOutEvent: function (e) {
                        var c = e.target,
                            o = R.Util.findParentByClassName(c, "sapCpCheckBoxWidget");
                        if (c.checked) {
                            R.Widget.toggleMissingMandatory(o, false);
                        }
                        R.ContentPage.checkMissingMandatoryFieldsLabel(o);
                    },
                    collectAnswer: function (c, f) {
                        var i = R.Widget.isMandatory(c),
                            o = c.getElementsByTagName("input")[0],
                            b = false;
                        if (o) {
                            b = o.checked;
                        }
                        if (i && !b) {
                            f(false);
                        } else {
                            var a = { WidgetKeyHash: R.Setting.get(c, "key"), WidgetValueKeyHash: "", Value: b ? "X" : "" };
                            f(a);
                        }
                    },
                },
                NoteWidget: {
                    collectAnswer: function (n, c) {
                        var w = R.Widget.isMandatory(n),
                            t = n.getElementsByTagName("textarea"),
                            N;
                        if (t[0]) {
                            N = t[0].value;
                        }
                        if (w && !N) {
                            c(false);
                        } else {
                            var a = { WidgetKeyHash: R.Setting.get(n, "key"), WidgetValueKeyHash: "", Value: N };
                            c(a);
                        }
                    },
                },
                DownloadWidget: {
                    prepare: function (d) {
                        var w = R.Widget.isMandatory(d),
                            c;
                        if (!w) {
                            return;
                        }
                        c = d.getElementsByTagName("input");
                        if (c[0]) {
                            R.Event.registerListener(c[0], "focusout", this.handleCheckBoxFocusOutEvent.bind(this));
                        }
                    },
                    handleCheckBoxFocusOutEvent: function (e) {
                        var c = e.target,
                            d = R.Util.findParentByClassName(c, "sapCpDownloadWidget");
                        if (c.checked) {
                            R.Widget.toggleMissingMandatory(d, false);
                        }
                        R.ContentPage.checkMissingMandatoryFieldsLabel(d);
                    },
                    collectAnswer: function (d, c) {
                        var w = R.Widget.isMandatory(d),
                            a = d.getElementsByTagName("input"),
                            b = false;
                        if (a[0]) {
                            b = a[0].checked;
                        }
                        if (w && !b) {
                            c(false);
                        } else {
                            var A = { WidgetKeyHash: R.Setting.get(d, "key"), WidgetValueKeyHash: "", Value: b ? "X" : "" };
                            c(A);
                        }
                    },
                },
                InteractionWidget: {
                    prepare: function (i) {
                        var w = R.Widget.isMandatory(i),
                            c;
                        if (!w) {
                            return;
                        }
                        c = i.getElementsByTagName("input");
                        if (c[0]) {
                            R.Event.registerListener(c[0], "focusout", this.handleCheckBoxFocusOutEvent.bind(this));
                        }
                    },
                    handleCheckBoxFocusOutEvent: function (e) {
                        var c = e.target,
                            i = R.Util.findParentByClassName(c, "sapCpInteractionWidget");
                        if (c.checked) {
                            R.Widget.toggleMissingMandatory(i, false);
                        }
                        R.ContentPage.checkMissingMandatoryFieldsLabel(i);
                    },
                    collectAnswer: function (i, c) {
                        var w = R.Widget.isMandatory(i),
                            a = i.getElementsByTagName("input"),
                            b = false;
                        if (a[0]) {
                            b = a[0].checked;
                        }
                        if (w && !b) {
                            c(false);
                        } else {
                            var A = { WidgetKeyHash: R.Setting.get(i, "key"), WidgetValueKeyHash: "", Value: b ? "X" : "" };
                            c(A);
                        }
                    },
                },
                CaptchaWidget: {
                    collectAnswer: function (c, f) {
                        R.CaptchaWidget.fetchCaptchaToken(c, function (s) {
                            var a = { WidgetKeyHash: R.Setting.get(c, "key"), WidgetValueKeyHash: "", Value: R.CaptchaWidget.buildAnswerValue(c, s) };
                            f(a);
                        });
                    },
                    fetchCaptchaToken: function (c, f) {
                        var s = R.Setting.get(c, "captcha-sitekey"),
                            a = R.Setting.get(c, "captcha-action");
                        window.grecaptcha.ready(function () {
                            window.grecaptcha.execute(s, { action: a }).then(function (b) {
                                f(b);
                            });
                        });
                    },
                    buildAnswerValue: function (c, s) {
                        var a = R.Setting.get(c, "captcha-key");
                        if (!s) {
                            return "";
                        }
                        if (!a) {
                            return s;
                        }
                        return "SAP_CAPTCHA_TOKEN:::" + a + ":::" + s;
                    },
                },
                ButtonWidget: {
                    prepare: function (b) {
                        var B;
                        B = b.getElementsByTagName("button");
                        if (B[0]) {
                            R.Event.registerListener(B[0], "click", this.handleButtonClickEvent.bind(this));
                        }
                    },
                    handleButtonClickEvent: function (e) {
                        var b = e.target,
                            B = R.Util.findParentByClassName(b, "sapCpButtonWidget");
                        if (e.preventDefault) {
                            e.preventDefault();
                        }
                        R.Result.sendSubmit(B);
                    },
                    collectAnswer: function (b, c, f) {
                        if (b === c) {
                            var a = { WidgetKeyHash: R.Setting.get(b, "key"), WidgetValueKeyHash: "", Value: "X" };
                            f(a);
                        } else {
                            f();
                        }
                    },
                    performFollowUpAction: function (b, c, f) {
                        var F = R.Setting.get(b, "follow-up-action");
                        if ((!F || F === R.Constants.FollowUpAction.FollowUpPage) && f) {
                            this.openFollowUpPage(f);
                        } else {
                            R.ContentPage.toggleSuccessMessage(c, true);
                        }
                    },
                    openFollowUpPage: function (f) {
                        var F = R.Util.appendOutboundId(f);
                        R.Util.openPage(window, F);
                    },
                    toggleDownloadLinkVisible: function (l, s) {
                        R.CSS.toggleClass(l, "sapCpButtonWidgetDownloadLinkVisible", s);
                    },
                    toggleLoading: function (b, l) {
                        var L = typeof l === "undefined" ? !R.CSS.hasClass(b, "sapCpButtonWidgetLoading") : l,
                            B = b.getElementsByTagName("button"),
                            i;
                        R.CSS.toggleClass(b, "sapCpButtonWidgetLoading", L);
                        for (i = 0; i < B.length; i++) {
                            if (L) {
                                B[i].setAttribute("disabled", "disabled");
                            } else {
                                B[i].removeAttribute("disabled");
                            }
                        }
                    },
                },
                Result: {
                    sendOpen: function (c, f) {
                        var p = R.Setting.get(c, "prefill-data") === "true",
                            o = R.Result.buildOpen(c, p);
                        R.Request.postResult(c, o, function (r) {
                            f(c, r);
                        });
                        if (!p) {
                            f(c, true);
                        }
                    },
                    sendSubmit: function (c) {
                        var o = R.Util.findParentByClassName(c, "sapCpContentPage");
                        R.Result.buildSubmit(o, c, function (s) {
                            var v = true;
                            R.ContentPage.toggleErrorMessage(o, false);
                            R.ContentPage.toggleSuccessMessage(o, false);
                            if (o.checkValidity) {
                                v = o.checkValidity();
                                R.ContentPage.toggleInvalid(o, !v);
                                if (o.reportValidity) {
                                    o.reportValidity();
                                }
                            }
                            if (v && s) {
                                R.ContentPage.toggleMissingMandatoryField(o, false);
                                R.ButtonWidget.toggleLoading(c, true);
                                R.Request.postResult(o, s, function (r) {
                                    R.Result.handleSubmitResponse(r, o, c);
                                    R.ButtonWidget.toggleLoading(c, false);
                                });
                            } else {
                                R.ContentPage.toggleMissingMandatoryField(o, true);
                            }
                        });
                    },
                    buildOpen: function (c, p) {
                        var r = this.buildResult(c, "OPEN");
                        if (p) {
                            r.ContactPersonalizationData = [];
                        }
                        return r;
                    },
                    buildSubmit: function (c, o, f) {
                        var r, m;
                        r = this.buildResult(c, "SUBMIT");
                        R.ContentPage.collectAnswers(c, o, function (a) {
                            m = !a;
                            R.ContentPage.toggleMissingMandatoryField(c, m);
                            if (m) {
                                f(null);
                                return;
                            }
                            r.Answers = a;
                            r.ResultValues = [];
                            f(r);
                        });
                    },
                    buildResult: function (c, e) {
                        var l = c.getElementsByClassName("sapCpLayout")[0];
                        var r = { ResultEvent: e, ContentPageKeyHash: R.Setting.get(c, "key"), LayoutKeyHash: R.Setting.get(l, "key"), Url: R.Util.getCurrentUrl() };
                        if (R.Setting.get(c, "lpkey")) {
                            r.LandingPageKeyHash = R.Setting.get(c, "lpkey");
                        }
                        if (R.ContentPage.isProductiveTestMode(c)) {
                            r.ProductiveTestMode = true;
                        }
                        var o = R.Util.getOutboundId();
                        if (o) {
                            r.OutboundId = o;
                        }
                        var s = R.Util.getCampaignId();
                        if (s) {
                            r.CampaignId = s;
                        }
                        return r;
                    },
                    handleSubmitResponse: function (r, c, o) {
                        if (R.Request.isErrorResponse(r)) {
                            var e = (r && r.error && r.error.message && r.error.message.value) || "Error";
                            if (this.checkMessagePresentable(r)) {
                                R.ContentPage.setErrorMessage(c, e);
                            } else {
                                R.ContentPage.setErrorMessage(c);
                            }
                            R.Console.warn(e);
                            R.ContentPage.toggleErrorMessage(c, true);
                            return;
                        }
                        if (r.ResultValues && r.ResultValues.results) {
                            this.handleResultValues(r.ResultValues.results, o);
                        }
                        R.ButtonWidget.performFollowUpAction(o, c, r.FollowUpPage);
                    },
                    checkMessagePresentable: function (r) {
                        var b = false;
                        var e;
                        if (r && r.error && r.error.code) {
                            if (r.error.code.indexOf("HPA_COMMON/") === 0) {
                                e = r.error.code.substring(11);
                                if (e === "415" || (e >= 420 && e <= 428)) {
                                    b = true;
                                }
                            }
                            if (r.error.code.indexOf("CUAN_CONTENT_PAGE/") === 0) {
                                b = true;
                            }
                        }
                        return b;
                    },
                    handleResultValues: function (r, c) {
                        var m, i;
                        for (i = 0; i < r.length; i++) {
                            m = r[i];
                            if (m.WidgetValueName === R.Constants.WidgetValueName.DownloadURI) {
                                this.handleDownloadURI(m, c);
                            }
                        }
                    },
                    handleDownloadURI: function (d, b) {
                        var D = d.Value,
                            l,
                            L,
                            s,
                            i;
                        R.Util.openDownload(window, D);
                        l = R.Node.getAllWithClassName(b, "sapCpLink");
                        for (i = 0; i < l.length; i++) {
                            L = l[i];
                            s = R.Setting.get(L, "download-key");
                            if (s === d.WidgetKeyHash) {
                                L.href = D;
                                R.ButtonWidget.toggleDownloadLinkVisible(L, true);
                                break;
                            }
                        }
                    },
                },
                Request: {
                    buildRequest: function (c, m, p) {
                        var M = m,
                            P = this.appendScenarioParameter(p, c),
                            h = new XMLHttpRequest();
                        if (C.CORS && !("withCredentials" in h)) {
                            if (typeof XDomainRequest === "function") {
                                // eslint-disable-next-line
                                h = new XDomainRequest();
                                if (M === "HEAD") {
                                    M = "GET";
                                }
                            } else {
                                R.Console.warn("Cross-Domain requests are not supported in your browser.");
                                return null;
                            }
                        }
                        h.open(M, P, true);
                        this.setRequestHeaders(h, c);
                        h.withCredentials = true;
                        return h;
                    },
                    appendScenarioParameter: function (p, c) {
                        var P = p,
                            m = R.getConfig(c);
                        if (m.AppendScenarioParameter) {
                            var s = "scenario=LPI",
                                t = "tenant=" + m.Tenant,
                                a = [s, t].join("&");
                            P += "?" + m.AppendScenarioParameter + "=" + btoa(a);
                        }
                        return P;
                    },
                    setRequestHeaders: function (h, c) {
                        if (h.setRequestHeader) {
                            var m = R.getConfig(c);
                            h.setRequestHeader("Content-Type", "application/json");
                            h.setRequestHeader("Accept", "application/json");
                            if (m.CSRFTokenHeader) {
                                h.setRequestHeader(m.CSRFTokenHeader, c.sapCpCSRFToken || "Fetch");
                            }
                            return true;
                        }
                        return false;
                    },
                    send: function (h, d, s, e) {
                        if (h instanceof XMLHttpRequest) {
                            h.onreadystatechange = function () {
                                if ((h.DONE && h.readyState !== h.DONE) || h.readyState !== XMLHttpRequest.DONE) {
                                    return;
                                }
                                if (h.status >= 200 && h.status < 300) {
                                    s(h);
                                } else {
                                    e(h);
                                }
                            };
                        } else {
                            h.onload = function () {
                                s(h);
                            };
                            h.onerror = function () {
                                e(h);
                            };
                            h.onprogress = function () {};
                            h.ontimeout = function () {};
                        }
                        if (d) {
                            h.send(JSON.stringify(d));
                        } else {
                            h.send();
                        }
                    },
                    fetchToken: function (c, f, u) {
                        var h = u ? "GET" : "HEAD",
                            i,
                            o,
                            m,
                            H;
                        for (i = 0; i < c.length; i++) {
                            o = c[i];
                            m = R.getConfig(o);
                            H = this.buildRequest(o, h, m.BasePath);
                            if (!m.CSRFTokenHeader) {
                                f([o], true);
                                return;
                            }
                            this.send(
                                H,
                                null,
                                function () {
                                    if (H.getResponseHeader) {
                                        o.sapCpCSRFToken = H.getResponseHeader(m.CSRFTokenHeader);
                                    }
                                    f([o], true);
                                },
                                function () {
                                    if (!u) {
                                        R.Request.fetchToken([o], f, true);
                                    } else {
                                        R.Console.warn("Technical error occurred.");
                                        f([o], false);
                                    }
                                }
                            );
                        }
                    },
                    postResult: function (c, r, f) {
                        var m = R.getConfig(c),
                            s = m.BasePath + m.ResultHeadersPath,
                            h = this.buildRequest(c, "POST", s);
                        this.send(
                            h,
                            r,
                            function () {
                                var a = JSON.parse(h.responseText);
                                if (typeof a === "string") {
                                    a = JSON.parse(a);
                                }
                                a = (a && a.d) || a;
                                f(a);
                            },
                            function () {
                                R.Console.warn("Technical error occurred.");
                                var a = null;
                                if (h.responseText) {
                                    a = JSON.parse(h.responseText);
                                }
                                f(a);
                            }
                        );
                    },
                    isErrorResponse: function (r) {
                        if (!r) {
                            return true;
                        }
                        return !!r.error;
                    },
                },
                Setting: {
                    get: function (n, s) {
                        return n.getAttribute("data-sap-cp-" + s);
                    },
                },
                Node: {
                    getAllWithClassName: function (n, c) {
                        if (n.getElementsByClassName) {
                            return n.getElementsByClassName(c);
                        }
                        if (n.querySelectorAll) {
                            return n.querySelectorAll("." + c);
                        }
                        R.Console.warn("Browser not supported!");
                        return [];
                    },
                    getFirstWithClassName: function (n, c) {
                        var N = R.Node.getAllWithClassName(n, c);
                        if (N && N[0]) {
                            return N[0];
                        }
                        return null;
                    },
                    createEmptyOptionElement: function (r) {
                        var e;
                        e = document.createElement("option");
                        e.value = "";
                        e.selected = "selected";
                        return e;
                    },
                },
                CSS: {
                    getClasses: function (n) {
                        if (n.classList) {
                            return n.classList;
                        }
                        var c = n.getAttribute("class");
                        return c.split(" ");
                    },
                    setClasses: function (n, c) {
                        var s = c.join(" ");
                        n.setAttribute("class", s);
                    },
                    hasClass: function (n, c) {
                        if (n.classList && n.classList.contains) {
                            return n.classList.contains(c);
                        }
                        var a = this.getClasses(n);
                        var i = a.indexOf(c);
                        return i >= 0;
                    },
                    addClass: function (n, c) {
                        if (n.classList && n.classList.add) {
                            n.classList.add(c);
                            return;
                        }
                        var h = this.hasClass(n, c);
                        if (h) {
                            return;
                        }
                        var a = this.getClasses(n);
                        a.push(c);
                        this.setClasses(n, a);
                    },
                    removeClass: function (n, c) {
                        if (n.classList && n.classList.remove) {
                            n.classList.remove(c);
                            return;
                        }
                        var h = this.hasClass(n, c);
                        if (!h) {
                            return;
                        }
                        var a = this.getClasses(n);
                        var i = a.indexOf(c);
                        a.splice(i, 1);
                        this.setClasses(n, a);
                    },
                    toggleClass: function (n, c, a) {
                        var A = a;
                        if (typeof A === "undefined") {
                            A = !this.hasClass(n, c);
                        }
                        if (A) {
                            return this.addClass(n, c);
                        }
                        return this.removeClass(n, c);
                    },
                },
                Util: {
                    findSiblingNodeByClassName: function (n, c) {
                        var o = R.Util.findParentByClassName(n, "sapCpContentPage");
                        return o.getElementsByClassName(c)[0];
                    },
                    findParentByClassName: function (n, c) {
                        if (!n || !c) {
                            return null;
                        }
                        if (R.CSS.hasClass(n, c)) {
                            return n;
                        }
                        var p = n.parentNode;
                        if (!p || p === n || p === document) {
                            return null;
                        }
                        return this.findParentByClassName(p, c);
                    },
                    findWidgetByKey: function (w, W) {
                        var o, i;
                        for (i = 0; i < w.length; i++) {
                            o = w[i];
                            if (R.Setting.get(o, "key") === W) {
                                return o;
                            }
                        }
                        return null;
                    },
                    getCurrentUrl: function () {
                        if (window !== window.top) {
                            return document.referrer;
                        }
                        return window.location.href;
                    },
                    getOutboundId: function () {
                        return this.getURLParameter("sap-outbound-id");
                    },
                    getCampaignId: function () {
                        return this.getURLParameter("sap-campaign-id");
                    },
                    getURLParameter: function (p) {
                        var q = window.location.search.substring(1).split("&");
                        for (var i = 0; i < q.length; i++) {
                            var P = q[i].split("="),
                                n = decodeURIComponent(P[0]);
                            if (n === p) {
                                return decodeURIComponent(P[1]);
                            }
                        }
                        return null;
                    },
                    appendOutboundId: function (u, o) {
                        var O = o || R.Util.getOutboundId();
                        if (O) {
                            return R.Util.appendURLParameter(u, "sap-outbound-id", O);
                        }
                        return u;
                    },
                    appendURLParameter: function (u, p, P) {
                        var s = p + "=" + P;
                        if (u.indexOf("?") > 0) {
                            return u.split("?")[0] + "?" + s + "&" + u.split("?")[1];
                        } else if (u.indexOf("#") > 0) {
                            return u.split("#")[0] + "?" + s + "#" + u.split("#")[1];
                        }
                        return u + "?" + s;
                    },
                    prefixHttpProtocol: function (u) {
                        var s = u.indexOf("/"),
                            d = u.indexOf("."),
                            p = u.indexOf("://");
                        if (s === 0 || d === 0) {
                            return u;
                        }
                        if (p < 0 || s !== p + 1) {
                            return "http://" + u;
                        }
                        return u;
                    },
                    openPage: function (w, p) {
                        if (!p) {
                            return;
                        }
                        var P = R.Util.prefixHttpProtocol(p);
                        w.location.href = P;
                    },
                    openDownload: function (w, d) {
                        if (!d) {
                            return;
                        }
                        var D = this.prefixHttpProtocol(d);
                        w.open(D, "_blank");
                    },
                },
                Event: {
                    registerListener: function (n, e, l) {
                        if (n.addEventListener) {
                            return n.addEventListener(e, l);
                        }
                        if (n.attachEvent) {
                            return n.attachEvent("on" + e, l);
                        }
                        R.Console.warn("Browser not supported!");
                        return false;
                    },
                },
                Console: {
                    warn: function (m) {
                        if (window.console && window.console.warn) {
                            window.console.warn(m);
                        }
                    },
                },
                Constants: { WidgetValueName: { DownloadURI: "DOWNLOAD_URI" }, FollowUpAction: { FollowUpPage: "01", SuccessMessage: "02" } },
            };
            window.sap = window.sap || {};
            window.sap.hpa = window.sap.hpa || {};
            window.sap.hpa.cei = window.sap.hpa.cei || {};
            window.sap.hpa.cei.cntpg = window.sap.hpa.cei.cntpg || {};
            window.sap.hpa.cei.cntpg.run = window.sap.hpa.cei.cntpg.run || R;
            if (window.sap.hpa.cei.cntpg.testEnvironment) {
                return;
            }
            R.Event.registerListener(document, "DOMContentLoaded", function () {
                R.initialize();
            });
            if (document.readyState === "complete" || document.readyState === "loaded" || document.readyState === "interactive") {
                R.initialize();
            }
        })();
      }, []);
    
  return (
    <div className="container py-5 m-padding no-pad-m-y" id="learn-more">
      <div className="row">
        <h2 className="color-1 text-center compatil-bold fw-bold pt-5 pb-3 align-left-m">Want to learn more or schedule a product demo/trial?</h2>

        <form id="application-MarketingContent-manage-component---ObjectView--DesignView--ContentPage"
        data-sap-cp-key="217E46A81F7F3A3A5F3793AB4928E187711C9608"
        className="sapCpContentPage sapCRLPage sapCpContentPageLoading" data-sap-cp-lpkey="" data-sap-cp-prefill-data="true"
        data-sap-cp-progres-enabled="false" data-sap-cp-version="${project.version}">
        <div id="application-MarketingContent-manage-component---ObjectView--DesignView--ContentPage-0L"
            data-sap-cp-key="C40088313F05A51C35041CE1AFD916607C91C016"
            className="sapCpLayout sapCRLLayout sapCRLLayoutVertical">
            <div id="application-MarketingContent-manage-component---ObjectView--DesignView--ContentPage-0L-0W"
                data-sap-cp-key="3205B42FD40629BDA5C5D636D2D832F33FAA34E8"
                className="sapCpWidget sapCRLWidget sapCpTextWidget" data-sap-cp-wprogres-enabled="false">
                    <div className="row pb-4">
                        <h5 className="open-sans color-4">Download our free educational and product materials or learn more about HOB:</h5>
                    </div>
            </div>
            <div className="row pb-5">
                <div className="col-md-6 col-sm-6 wrap-pb">
                    <div className="form-check pb-2">
                        <div id="application-MarketingContent-manage-component---ObjectView--DesignView--ContentPage-0L-1W"
                            data-sap-cp-key="2736C209DA9F5A17F87EC3A3CB1EFFCB1A4D905D"
                            className="sapCpWidget sapCRLWidget sapCpDownloadWidget sapCpCheckBoxElementWidget"
                            data-sap-cp-wprogres-enabled="false">
                            <div id="__box10" className="sapCpCheckBox">
                                <input className="form-check-input" type="checkbox" />
                            </div>
                            <label id="__label37" className="open-sans color-3 form-check-label">Chlorhexidine Protected Catheters Overview
                                Brochure
                            </label>
                        </div>
                    </div>
                    <div className="form-check pb-2">
                        <div id="application-MarketingContent-manage-component---ObjectView--DesignView--ContentPage-0L-2W"
                            data-sap-cp-key="637373E8DBB8D5972496A2F979E9486E4D027754"
                            className="sapCpWidget sapCRLWidget sapCpDownloadWidget sapCpCheckBoxElementWidget"
                            data-sap-cp-wprogres-enabled="false">
                            <div id="__box11" className="sapCpCheckBox">
                                <input className="form-check-input" type="checkbox" />
                            </div>
                            <label id="__label38" className="open-sans color-3 form-check-label">CVC Cost Savings Brochure
                            </label>
                        </div>
                    </div>
                    <div className="form-check pb-2">
                        <div id="application-MarketingContent-manage-component---ObjectView--DesignView--ContentPage-0L-3W"
                            data-sap-cp-key="8EB710778AB52F97A7148D06E47A831CA2242536"
                            className="sapCpWidget sapCRLWidget sapCpDownloadWidget sapCpCheckBoxElementWidget"
                            data-sap-cp-wprogres-enabled="false">
                            <div id="__box12" className="sapCpCheckBox">
                                <input className="form-check-input" type="checkbox" />
                            </div>
                            <label id="__label39" className="open-sans color-3 form-check-label">Hemodialysis Brochure
                            </label>
                        </div>
                    </div>
                    <div className="form-check pb-2">
                        <div id="application-MarketingContent-manage-component---ObjectView--DesignView--ContentPage-0L-4W"
                            data-sap-cp-key="6D518272755D963602F479270E6964606B296B94"
                            className="sapCpWidget sapCRLWidget sapCpDownloadWidget sapCpCheckBoxElementWidget"
                            data-sap-cp-wprogres-enabled="false">
                            <div id="__box13" className="sapCpCheckBox">
                                <input className="form-check-input" type="checkbox" />
                            </div>
                            <label id="__label40" className="open-sans color-3 form-check-label">Midline Brochure
                            </label>
                        </div>
                    </div>
                </div>

                <div className="col-md-6 col-sm-6">
                    <div className="form-check pb-2">
                        <div id="application-MarketingContent-manage-component---ObjectView--DesignView--ContentPage-0L-5W"
                            data-sap-cp-key="543EF57978B8828001BA85D5780EA2E29F49B2B6"
                            className="sapCpWidget sapCRLWidget sapCpDownloadWidget sapCpCheckBoxElementWidget"
                            data-sap-cp-wprogres-enabled="false">
                            <div id="__box14" className="sapCpCheckBox">
                                <input className="form-check-input" type="checkbox" />
                            </div>
                            <label id="__label41" className="open-sans color-3 form-check-label">PICC Brochure
                            </label>
                        </div>
                    </div>
                    <div className="form-check pb-2">
                        <div id="application-MarketingContent-manage-component---ObjectView--DesignView--ContentPage-0L-6W"
                            data-sap-cp-key="014A39717D84007BACFF1B5D43908A3B162618D1"
                            className="sapCpWidget sapCRLWidget sapCpDownloadWidget sapCpCheckBoxElementWidget"
                            data-sap-cp-wprogres-enabled="false">
                            <div id="__box15" className="sapCpCheckBox">
                                <input className="form-check-input" type="checkbox" />
                            </div>
                            <label id="__label42" className="open-sans color-3 form-check-label">JACC Brochure
                            </label>
                        </div>
                    </div>
                    <div className="form-check pb-2">
                        <div id="application-MarketingContent-manage-component---ObjectView--DesignView--ContentPage-0L-6W"
                            data-sap-cp-key="0AD9C8B730014BC3F3FA549A3FB651FEF4F175B3"
                            className="sapCpWidget sapCRLWidget sapCpDownloadWidget sapCpCheckBoxElementWidget"
                            data-sap-cp-wprogres-enabled="false">
                            <div id="__box16" className="sapCpCheckBox">
                                <input className="form-check-input" type="checkbox" />
                            </div>
                            <label id="__label43" className="open-sans color-3 form-check-label">Hospital-Onset Bacteremia and Fungemia (HOB)
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <p className="open-sans text-center fst-italic mb-4">Products may not be available in all countries. Please contact your local representative.</p>
            <div className="row">
                <div className="col-md-6 col-sm6">
                    <div className="form-group pb-4">
                        <div id="application-MarketingContent-manage-component---ObjectView--DesignView--ContentPage-0L-8W"
                        data-sap-cp-key="408812A009F24FA8D61050EA4D19DA7B5A20CA02"
                        className="sapCpWidget sapCRLWidget sapCpInputWidget sapCpWidgetMandatory sapCpContactAttribute-NAME_FIRST"
                        data-sap-cp-wprogres-enabled="false">
                        <label id="__label44" className="fw-bold color-3 pb-2 sapCpLabel sapCpLabelRequired" htmlFor="__input21">First
                        Name</label>
                        <input id="__input21" className="form-control sapCpInput" type="text" required="required"
                        maxlength="40" placeholder="First Name" />
                        </div>  
                    </div>   
                </div>
                <div className="col-md-6 col-sm6">
                    <div className="form-group pb-4">
                        <div id="application-MarketingContent-manage-component---ObjectView--DesignView--ContentPage-0L-9W"
                        data-sap-cp-key="6B94AC9B2FFCD007B150AD40C08E84576BE78BA8"
                        className="sapCpWidget sapCRLWidget sapCpInputWidget sapCpWidgetMandatory sapCpContactAttribute-NAME_LAST"
                        data-sap-cp-wprogres-enabled="false">
                        <label id="__label45" className="fw-bold color-3 pb-2 sapCpLabel sapCpLabelRequired" htmlFor="__input22">Last
                        Name</label>
                        <input id="__input22" className="form-control sapCpInput" type="text" required="required"
                        maxlength="40" placeholder="Last Name"/>
                        </div>  
                    </div>   
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-sm6">
                    <div className="form-group pb-4">
                        <div id="application-MarketingContent-manage-component---ObjectView--DesignView--ContentPage-0L-10W"
                        data-sap-cp-key="8E4117726054EA2648DEC6AA3DA9A290831FF2E2"
                        className="sapCpWidget sapCRLWidget sapCpInputWidget sapCpWidgetMandatory sapCpContactAttribute-YY1_TITLE_MPS"
                        data-sap-cp-wprogres-enabled="false">
                        <label id="__label46" className="fw-bold color-3 pb-2 sapCpLabel sapCpLabelRequired" htmlFor="__input23">Title</label>
                        <input id="__input23" className="form-control sapCpInput" type="text" required="required"
                        maxlength="128" placeholder="Title"/>
                        </div>  
                    </div>   
                </div>
                <div className="col-md-6 col-sm6">
                    <div className="form-group pb-4">
                        <div id="application-MarketingContent-manage-component---ObjectView--DesignView--ContentPage-0L-11W"
                        data-sap-cp-key="6F8F8A66D18062AC6DD324715FC5487EC4E02F13"
                        className="sapCpWidget sapCRLWidget sapCpInputWidget sapCpWidgetMandatory sapCpContactAttribute-SMTP_ADDR"
                        data-sap-cp-wprogres-enabled="false">
                        <label id="__label47" className="fw-bold color-3 pb-2 sapCpLabel sapCpLabelRequired" htmlFor="__input24">Email Address</label>
                        <input id="__input24" className="form-control sapCpInput" type="email" required="required"
                        maxlength="241" data-sap-cp-validationmessage="Email address should have @ and a period. For example: user@example.com" placeholder="Email Address"/>
                        </div>  
                    </div>   
                </div>
            </div>
            <div className="row pb-4">
                <div className="col-md-6 col-sm6">
                    <div className="form-group pb-4">
                        <div id="application-MarketingContent-manage-component---ObjectView--DesignView--ContentPage-0L-12W"
                        data-sap-cp-key="DF1086CD95CF3510DEE8C3B54BADDB2C9B796FDA"
                        className="sapCpWidget sapCRLWidget sapCpInputWidget sapCpWidgetMandatory sapCpContactAttribute-YY1_COMPANY_ENH"
                        data-sap-cp-wprogres-enabled="false">
                        <label id="__label48" className="fw-bold color-3 pb-2 sapCpLabel sapCpLabelRequired" htmlFor="__input25">Institution</label>
                        <input id="__input25" className="form-control sapCpInput" type="text" required="required"
                        maxlength="255" placeholder="Institution"/>
                        </div>  
                    </div>   
                </div>
                <div className="col-md-6 col-sm6">
                    <div className="form-group pb-4">
                        <div id="application-MarketingContent-manage-component---ObjectView--DesignView--ContentPage-0L-13W"
                        data-sap-cp-key="C43F09AF6C2C56D1DB990B75C1700183B1D11660"
                        className="sapCpWidget sapCRLWidget sapCpInputWidget sapCpWidgetMandatory sapCpContactAttribute-POSTCODE1"
                        data-sap-cp-wprogres-enabled="false">
                        <label id="__label49" className="fw-bold color-3 pb-2 sapCpLabel sapCpLabelRequired" htmlFor="__input26">Zip/Postal Code</label>
                        <input id="__input26" className="form-control sapCpInput" type="text" required="required"
                        maxlength="241" placeholder="Zip/Postal Code"/>
                        </div>  
                    </div>   
                </div>
            </div>
            <div id="application-MarketingContent-manage-component---ObjectView--DesignView--ContentPage-0L-14W"
                data-sap-cp-key="F90CB7FC4810358E7BDFE261DDA83D04238FE1A8"
                class="sapCpWidget sapCRLWidget sapCpInputWidget sapCpWidgetHidden sapCpContactAttribute-COUNTRY"
                data-sap-cp-wprogres-enabled="false">
                <div class="sapCpWidgetContent sapCpWidgetContentLeft sapCRLWidgetContent sapCRLWidgetContentLeft"
                    style={{ width: "20%" }}><label id="__label50" class="sapCpLabel" for="__down1">Country/Region</label>
                </div>
                <div class="sapCpWidgetContent sapCpWidgetContentRight sapCRLWidgetContent sapCRLWidgetContentRight"
                    style={{ "padding-left": "20%" }}><select id="__down1" class="sapCpDropDown">
                        <option label="USA" value="US" selected="selected">USA</option>
                        <option label=" " value=""> </option>
                        <option label="Afghanistan" value="AF">Afghanistan</option>
                        <option label="Aland Islands" value="AX">Aland Islands</option>
                        <option label="Albania" value="AL">Albania</option>
                        <option label="Algeria" value="DZ">Algeria</option>
                        <option label="Amer.Virgin Is." value="VI">Amer.Virgin Is.</option>
                        <option label="Andorra" value="AD">Andorra</option>
                        <option label="Angola" value="AO">Angola</option>
                        <option label="Anguilla" value="AI">Anguilla</option>
                        <option label="Antarctica" value="AQ">Antarctica</option>
                        <option label="Antigua/Barbuda" value="AG">Antigua/Barbuda</option>
                        <option label="Argentina" value="AR">Argentina</option>
                        <option label="Armenia" value="AM">Armenia</option>
                        <option label="Aruba" value="AW">Aruba</option>
                        <option label="Australia" value="AU">Australia</option>
                        <option label="Austria" value="AT">Austria</option>
                        <option label="Azerbaijan" value="AZ">Azerbaijan</option>
                        <option label="Bahamas" value="BS">Bahamas</option>
                        <option label="Bahrain" value="BH">Bahrain</option>
                        <option label="Bangladesh" value="BD">Bangladesh</option>
                        <option label="Barbados" value="BB">Barbados</option>
                        <option label="Belarus" value="BY">Belarus</option>
                        <option label="Belgium" value="BE">Belgium</option>
                        <option label="Belize" value="BZ">Belize</option>
                        <option label="Benin" value="BJ">Benin</option>
                        <option label="Bermuda" value="BM">Bermuda</option>
                        <option label="Bhutan" value="BT">Bhutan</option>
                        <option label="Bolivia" value="BO">Bolivia</option>
                        <option label="Bonaire, Saba" value="BQ">Bonaire, Saba</option>
                        <option label="Bosnia-Herz." value="BA">Bosnia-Herz.</option>
                        <option label="Botswana" value="BW">Botswana</option>
                        <option label="Bouvet Islands" value="BV">Bouvet Islands</option>
                        <option label="Brazil" value="BR">Brazil</option>
                        <option label="Brit.Ind.Oc.Ter" value="IO">Brit.Ind.Oc.Ter</option>
                        <option label="Brit.Virgin Is." value="VG">Brit.Virgin Is.</option>
                        <option label="Brunei Daruss." value="BN">Brunei Daruss.</option>
                        <option label="Bulgaria" value="BG">Bulgaria</option>
                        <option label="Burkina Faso" value="BF">Burkina Faso</option>
                        <option label="Burundi" value="BI">Burundi</option>
                        <option label="Cabo Verde" value="CV">Cabo Verde</option>
                        <option label="Cambodia" value="KH">Cambodia</option>
                        <option label="Cameroon" value="CM">Cameroon</option>
                        <option label="Canada" value="CA">Canada</option>
                        <option label="CAR" value="CF">CAR</option>
                        <option label="Cayman Islands" value="KY">Cayman Islands</option>
                        <option label="Chad" value="TD">Chad</option>
                        <option label="Chile" value="CL">Chile</option>
                        <option label="China" value="CN">China</option>
                        <option label="Christmas Islnd" value="CX">Christmas Islnd</option>
                        <option label="Cocos Islands" value="CC">Cocos Islands</option>
                        <option label="Colombia" value="CO">Colombia</option>
                        <option label="Comoros" value="KM">Comoros</option>
                        <option label="Cook Islands" value="CK">Cook Islands</option>
                        <option label="Costa Rica" value="CR">Costa Rica</option>
                        <option label="Cote d'Ivoire" value="CI">Cote d'Ivoire</option>
                        <option label="Croatia" value="HR">Croatia</option>
                        <option label="Cuba" value="CU">Cuba</option>
                        <option label="Curaçao" value="CW">Curaçao</option>
                        <option label="Cyprus" value="CY">Cyprus</option>
                        <option label="Czech Republic" value="CZ">Czech Republic</option>
                        <option label="Dem. Rep. Congo" value="CD">Dem. Rep. Congo</option>
                        <option label="Denmark" value="DK">Denmark</option>
                        <option label="Djibouti" value="DJ">Djibouti</option>
                        <option label="Dominica" value="DM">Dominica</option>
                        <option label="Dominican Rep." value="DO">Dominican Rep.</option>
                        <option label="Ecuador" value="EC">Ecuador</option>
                        <option label="Egypt" value="EG">Egypt</option>
                        <option label="El Salvador" value="SV">El Salvador</option>
                        <option label="Equatorial Guin" value="GQ">Equatorial Guin</option>
                        <option label="Eritrea" value="ER">Eritrea</option>
                        <option label="Estonia" value="EE">Estonia</option>
                        <option label="Eswatini" value="SZ">Eswatini</option>
                        <option label="Ethiopia" value="ET">Ethiopia</option>
                        <option label="Falkland Islnds" value="FK">Falkland Islnds</option>
                        <option label="Faroe Islands" value="FO">Faroe Islands</option>
                        <option label="Fiji" value="FJ">Fiji</option>
                        <option label="Finland" value="FI">Finland</option>
                        <option label="France" value="FR">France</option>
                        <option label="Frenc.Polynesia" value="PF">Frenc.Polynesia</option>
                        <option label="French Guayana" value="GF">French Guayana</option>
                        <option label="French S.Territ" value="TF">French S.Territ</option>
                        <option label="Gabon" value="GA">Gabon</option>
                        <option label="Gambia" value="GM">Gambia</option>
                        <option label="Georgia" value="GE">Georgia</option>
                        <option label="Germany" value="DE">Germany</option>
                        <option label="Ghana" value="GH">Ghana</option>
                        <option label="Gibraltar" value="GI">Gibraltar</option>
                        <option label="Greece" value="GR">Greece</option>
                        <option label="Greenland" value="GL">Greenland</option>
                        <option label="Grenada" value="GD">Grenada</option>
                        <option label="Guadeloupe" value="GP">Guadeloupe</option>
                        <option label="Guam" value="GU">Guam</option>
                        <option label="Guatemala" value="GT">Guatemala</option>
                        <option label="Guernsey" value="GG">Guernsey</option>
                        <option label="Guinea" value="GN">Guinea</option>
                        <option label="Guinea-Bissau" value="GW">Guinea-Bissau</option>
                        <option label="Guyana" value="GY">Guyana</option>
                        <option label="Haiti" value="HT">Haiti</option>
                        <option label="Heard/McDon.Isl" value="HM">Heard/McDon.Isl</option>
                        <option label="Honduras" value="HN">Honduras</option>
                        <option label="Hong Kong" value="HK">Hong Kong</option>
                        <option label="Hungary" value="HU">Hungary</option>
                        <option label="Iceland" value="IS">Iceland</option>
                        <option label="India" value="IN">India</option>
                        <option label="Indonesia" value="ID">Indonesia</option>
                        <option label="Iran" value="IR">Iran</option>
                        <option label="Iraq" value="IQ">Iraq</option>
                        <option label="Ireland" value="IE">Ireland</option>
                        <option label="Isle of Man" value="IM">Isle of Man</option>
                        <option label="Israel" value="IL">Israel</option>
                        <option label="Italy" value="IT">Italy</option>
                        <option label="Jamaica" value="JM">Jamaica</option>
                        <option label="Japan" value="JP">Japan</option>
                        <option label="Jersey" value="JE">Jersey</option>
                        <option label="Jordan" value="JO">Jordan</option>
                        <option label="Kazakhstan" value="KZ">Kazakhstan</option>
                        <option label="Kenya" value="KE">Kenya</option>
                        <option label="Kiribati" value="KI">Kiribati</option>
                        <option label="Kuwait" value="KW">Kuwait</option>
                        <option label="Kyrgyzstan" value="KG">Kyrgyzstan</option>
                        <option label="Laos" value="LA">Laos</option>
                        <option label="Latvia" value="LV">Latvia</option>
                        <option label="Lebanon" value="LB">Lebanon</option>
                        <option label="Lesotho" value="LS">Lesotho</option>
                        <option label="Liberia" value="LR">Liberia</option>
                        <option label="Libya" value="LY">Libya</option>
                        <option label="Liechtenstein" value="LI">Liechtenstein</option>
                        <option label="Lithuania" value="LT">Lithuania</option>
                        <option label="Luxembourg" value="LU">Luxembourg</option>
                        <option label="Macao" value="MO">Macao</option>
                        <option label="Madagascar" value="MG">Madagascar</option>
                        <option label="Malawi" value="MW">Malawi</option>
                        <option label="Malaysia" value="MY">Malaysia</option>
                        <option label="Maldives" value="MV">Maldives</option>
                        <option label="Mali" value="ML">Mali</option>
                        <option label="Malta" value="MT">Malta</option>
                        <option label="Marshall Islnds" value="MH">Marshall Islnds</option>
                        <option label="Martinique" value="MQ">Martinique</option>
                        <option label="Mauretania" value="MR">Mauretania</option>
                        <option label="Mauritius" value="MU">Mauritius</option>
                        <option label="Mayotte" value="YT">Mayotte</option>
                        <option label="Mexico" value="MX">Mexico</option>
                        <option label="Micronesia" value="FM">Micronesia</option>
                        <option label="Minor Outl.Isl." value="UM">Minor Outl.Isl.</option>
                        <option label="Moldova" value="MD">Moldova</option>
                        <option label="Monaco" value="MC">Monaco</option>
                        <option label="Mongolia" value="MN">Mongolia</option>
                        <option label="Montenegro" value="ME">Montenegro</option>
                        <option label="Montserrat" value="MS">Montserrat</option>
                        <option label="Morocco" value="MA">Morocco</option>
                        <option label="Mozambique" value="MZ">Mozambique</option>
                        <option label="Myanmar" value="MM">Myanmar</option>
                        <option label="N.Mariana Islnd" value="MP">N.Mariana Islnd</option>
                        <option label="Namibia" value="NA">Namibia</option>
                        <option label="Nauru" value="NR">Nauru</option>
                        <option label="Nepal" value="NP">Nepal</option>
                        <option label="Netherlands" value="NL">Netherlands</option>
                        <option label="New Caledonia" value="NC">New Caledonia</option>
                        <option label="New Zealand" value="NZ">New Zealand</option>
                        <option label="Nicaragua" value="NI">Nicaragua</option>
                        <option label="Niger" value="NE">Niger</option>
                        <option label="Nigeria" value="NG">Nigeria</option>
                        <option label="Niue" value="NU">Niue</option>
                        <option label="Norfolk Islands" value="NF">Norfolk Islands</option>
                        <option label="North Korea" value="KP">North Korea</option>
                        <option label="North Macedonia" value="MK">North Macedonia</option>
                        <option label="Norway" value="NO">Norway</option>
                        <option label="Oman" value="OM">Oman</option>
                        <option label="Pakistan" value="PK">Pakistan</option>
                        <option label="Palau" value="PW">Palau</option>
                        <option label="Palestine" value="PS">Palestine</option>
                        <option label="Panama" value="PA">Panama</option>
                        <option label="Pap. New Guinea" value="PG">Pap. New Guinea</option>
                        <option label="Paraguay" value="PY">Paraguay</option>
                        <option label="Peru" value="PE">Peru</option>
                        <option label="Philippines" value="PH">Philippines</option>
                        <option label="Pitcairn Islnds" value="PN">Pitcairn Islnds</option>
                        <option label="Poland" value="PL">Poland</option>
                        <option label="Portugal" value="PT">Portugal</option>
                        <option label="Puerto Rico" value="PR">Puerto Rico</option>
                        <option label="Qatar" value="QA">Qatar</option>
                        <option label="Rep.of Congo" value="CG">Rep.of Congo</option>
                        <option label="Reunion" value="RE">Reunion</option>
                        <option label="Romania" value="RO">Romania</option>
                        <option label="Russian Fed." value="RU">Russian Fed.</option>
                        <option label="Rwanda" value="RW">Rwanda</option>
                        <option label="S. Sandwich Ins" value="GS">S. Sandwich Ins</option>
                        <option label="S.Tome,Principe" value="ST">S.Tome,Principe</option>
                        <option label="Saint Helena" value="SH">Saint Helena</option>
                        <option label="Saint Martin" value="MF">Saint Martin</option>
                        <option label="Samoa" value="WS">Samoa</option>
                        <option label="Samoa, America" value="AS">Samoa, America</option>
                        <option label="San Marino" value="SM">San Marino</option>
                        <option label="Saudi Arabia" value="SA">Saudi Arabia</option>
                        <option label="Senegal" value="SN">Senegal</option>
                        <option label="Serbia" value="RS">Serbia</option>
                        <option label="Seychelles" value="SC">Seychelles</option>
                        <option label="Sierra Leone" value="SL">Sierra Leone</option>
                        <option label="Singapore" value="SG">Singapore</option>
                        <option label="Sint Maarten" value="SX">Sint Maarten</option>
                        <option label="Slovakia" value="SK">Slovakia</option>
                        <option label="Slovenia" value="SI">Slovenia</option>
                        <option label="Solomon Islands" value="SB">Solomon Islands</option>
                        <option label="Somalia" value="SO">Somalia</option>
                        <option label="South Africa" value="ZA">South Africa</option>
                        <option label="South Korea" value="KR">South Korea</option>
                        <option label="South Sudan" value="SS">South Sudan</option>
                        <option label="Spain" value="ES">Spain</option>
                        <option label="Sri Lanka" value="LK">Sri Lanka</option>
                        <option label="St Barthelemy" value="BL">St Barthelemy</option>
                        <option label="St Kitts&amp;Nevis" value="KN">St Kitts&amp;Nevis</option>
                        <option label="St. Lucia" value="LC">St. Lucia</option>
                        <option label="St. Vincent" value="VC">St. Vincent</option>
                        <option label="St.Pier,Miquel." value="PM">St.Pier,Miquel.</option>
                        <option label="Sudan" value="SD">Sudan</option>
                        <option label="Suriname" value="SR">Suriname</option>
                        <option label="Svalbard" value="SJ">Svalbard</option>
                        <option label="Sweden" value="SE">Sweden</option>
                        <option label="Switzerland" value="CH">Switzerland</option>
                        <option label="Syria" value="SY">Syria</option>
                        <option label="Taiwan" value="TW">Taiwan</option>
                        <option label="Tajikistan" value="TJ">Tajikistan</option>
                        <option label="Tanzania" value="TZ">Tanzania</option>
                        <option label="Thailand" value="TH">Thailand</option>
                        <option label="Timor-Leste" value="TL">Timor-Leste</option>
                        <option label="Togo" value="TG">Togo</option>
                        <option label="Tokelau Islands" value="TK">Tokelau Islands</option>
                        <option label="Tonga" value="TO">Tonga</option>
                        <option label="Trinidad,Tobago" value="TT">Trinidad,Tobago</option>
                        <option label="Tunisia" value="TN">Tunisia</option>
                        <option label="Türkiye" value="TR">Türkiye</option>
                        <option label="Turkmenistan" value="TM">Turkmenistan</option>
                        <option label="Turksh Caicosin" value="TC">Turksh Caicosin</option>
                        <option label="Tuvalu" value="TV">Tuvalu</option>
                        <option label="Uganda" value="UG">Uganda</option>
                        <option label="Ukraine" value="UA">Ukraine</option>
                        <option label="United Kingdom" value="GB">United Kingdom</option>
                        <option label="Uruguay" value="UY">Uruguay</option>
                        <option label="Utd.Arab Emir." value="AE">Utd.Arab Emir.</option>
                        <option label="Uzbekistan" value="UZ">Uzbekistan</option>
                        <option label="Vanuatu" value="VU">Vanuatu</option>
                        <option label="Vatican City" value="VA">Vatican City</option>
                        <option label="Venezuela" value="VE">Venezuela</option>
                        <option label="Vietnam" value="VN">Vietnam</option>
                        <option label="Wallis,Futuna" value="WF">Wallis,Futuna</option>
                        <option label="West Sahara" value="EH">West Sahara</option>
                        <option label="Yemen" value="YE">Yemen</option>
                        <option label="Zambia" value="ZM">Zambia</option>
                        <option label="Zimbabwe" value="ZW">Zimbabwe</option>
                    </select></div>
                <div class="sapCpWidgetFixContent sapCRLWidgetFixContent"></div>
            </div>
            <div id="application-MarketingContent-manage-component---ObjectView--DesignView--ContentPage-0L-15W"
                data-sap-cp-key="F39EA48A98AE043B1E4543D6CD76EE58409640DE"
                class="sapCpWidget sapCRLWidget sapCpInputWidget sapCpWidgetHidden sapCpContactAttribute-YY1_LEADCREATIONREASON_MPS"
                data-sap-cp-wprogres-enabled="false">
                <div class="sapCpWidgetContent sapCpWidgetContentLeft sapCRLWidgetContent sapCRLWidgetContentLeft"
                    style={{ width: "20%" }}><label id="__label51" class="sapCpLabel" for="__input28">Lead Creation Reason
                    </label></div>
                <div class="sapCpWidgetContent sapCpWidgetContentRight sapCRLWidgetContent sapCRLWidgetContentRight"
                    style={{ "padding-left": "20%" }}><input id="__input28" class="sapCpInput" type="text"
                        value="New Lead from Chlorhexidine Landing Page" maxlength="255" /></div>
                <div class="sapCpWidgetFixContent sapCRLWidgetFixContent"></div>
            </div>
            <div id="application-MarketingContent-manage-component---ObjectView--DesignView--ContentPage-0L-16W"
                data-sap-cp-key="9BD29C21E8FC1B566C03B15AFDA9FA23C1780723"
                class="sapCpWidget sapCRLWidget sapCpInputWidget sapCpWidgetHidden sapCpContactAttribute-YY1_LEADSOURCE_MPS"
                data-sap-cp-wprogres-enabled="false">
                <div class="sapCpWidgetContent sapCpWidgetContentLeft sapCRLWidgetContent sapCRLWidgetContentLeft"
                    style={{ width: "20%" }}><label id="__label52" class="sapCpLabel" for="__input29">Lead Source</label></div>
                <div class="sapCpWidgetContent sapCpWidgetContentRight sapCRLWidgetContent sapCRLWidgetContentRight"
                    style={{ "padding-left": "20%" }}><input id="__input29" class="sapCpInput" type="text" value="Web"
                        maxlength="30" /></div>
                <div class="sapCpWidgetFixContent sapCRLWidgetFixContent"></div>
            </div>
            <div id="application-MarketingContent-manage-component---ObjectView--DesignView--ContentPage-0L-17W"
                data-sap-cp-key="5082D1A1BFDCE9D5C92C7DF0736314C0624840EE"
                class="sapCpWidget sapCRLWidget sapCpInputWidget sapCpWidgetHidden sapCpContactAttribute-YY1_PREFERREDLANGUAGE_MPS"
                data-sap-cp-wprogres-enabled="false">
                <div class="sapCpWidgetContent sapCpWidgetContentLeft sapCRLWidgetContent sapCRLWidgetContentLeft"
                    style={{ width: "20%" }}><label id="__label53" class="sapCpLabel" for="__input30">Preferred
                        Language</label></div>
                <div class="sapCpWidgetContent sapCpWidgetContentRight sapCRLWidgetContent sapCRLWidgetContentRight"
                    style={{ "padding-left": "20%" }}><input id="__input30" class="sapCpInput" type="text"
                        value="English (American) " maxlength="40" /></div>
                <div class="sapCpWidgetFixContent sapCRLWidgetFixContent"></div>
            </div>
            <div className="row pb-4">
                <div className="col-md-12 col-sm-6">
                    <div className="form-check pb-2">
                        <div id="application-MarketingContent-manage-component---ObjectView--DesignView--ContentPage-0L-18W"
                        data-sap-cp-key="CD1395DCAF6DA4FFE5336A5F7870B0C4193B450E"
                        class="sapCpWidget sapCRLWidget sapCpInteractionWidget sapCpCheckBoxElementWidget"
                        data-sap-cp-wprogres-enabled="false">
                            <div id="__box17" className="sapCpCheckBox">
                                <input type="checkbox" className="form-check-input"/>
                            </div>
                            <label id="__label54"
                            className="open-sans color-3 form-check-label sapCpLabel sapCpLabelRequiredBefore">I’d like to talk to my local Teleflex Vascular
                            representative about setting up a product demo or trial.</label>
                        </div>
                    </div>
                    <div className="form-check indent py-3">
                        <div id="application-MarketingContent-manage-component---ObjectView--DesignView--ContentPage-0L-19W"
                            data-sap-cp-key="A1AE29EDFB23F02FD3C3321AFE1E98C85363462A"
                            class="sapCpWidget sapCRLWidget sapCpTextWidget" data-sap-cp-wprogres-enabled="false">
                                <div class="sapCpWidgetContentNoIndent sapCRLWidgetContentNoIndent">
                                <p>Teleflex is committed to protecting and respecting your privacy, and we’ll only use your personal
                                information to administer your account and to provide the products and services you requested
                                from us. Please review the <a title="Teleflex Privacy Policy"
                                href="https://www.teleflex.com/usa/en/legal/internet-privacy-policy/index.html#"
                                target="_blank" rel="noopener noreferrer">Teleflex Privacy Policy</a>.</p>
                                </div>
                        </div>
                    </div>
                    <div className="form-check pb-2">
                        <div id="application-MarketingContent-manage-component---ObjectView--DesignView--ContentPage-0L-20W"
                        data-sap-cp-key="8BA7582DDD8EB01B952354D9916F0EE1DFFE5A1F"
                        class="sapCpWidget sapCRLWidget sapCpInteractionWidget sapCpCheckBoxElementWidget"
                        data-sap-cp-wprogres-enabled="false">
                            <div id="__box18" className="sapCpCheckBox">
                                <input type="checkbox" className="form-check-input"/>
                            </div>
                            <label id="__label55"
                            className="open-sans color-3 form-check-label sapCpLabel sapCpLabelRequiredBefore">I consent to receiving emails related to Teleflex
                            products and services.</label>
                        </div>
                    </div>
                    <div className="form-check pb-2">
                        <div id="application-MarketingContent-manage-component---ObjectView--DesignView--ContentPage-0L-21W"
                        data-sap-cp-key="54390BF972975A1B704312B0CF99FA3B7DC0BE87"
                        class="sapCpWidget sapCRLWidget sapCpInteractionWidget sapCpCheckBoxElementWidget"
                        data-sap-cp-wprogres-enabled="false">
                            <div id="__box19" className="sapCpCheckBox">
                                <input type="checkbox" className="form-check-input"/>
                            </div>
                            <label id="__label56"
                            className="open-sans color-3 form-check-label sapCpLabel sapCpLabelRequiredBefore sapCpLabelRequired"><span class="sup-hang"><sup>*</sup></span>I have read and
                            understand Teleflex's privacy policy.</label>
                        </div>
                    </div>
                </div>
            </div>
            <div id="application-MarketingContent-manage-component---ObjectView--DesignView--ContentPage-0L-22W"
                data-sap-cp-key="6D7199FF95318E793CA3F3E25739E8EFD6C8A791"
                class="sapCpWidget sapCRLWidget sapCpInputWidget sapCpWidgetHidden sapCpCInteractionAttribute-CONTENT_TITLE sapCpContactAttribute-"
                data-sap-cp-wprogres-enabled="false">
                <div class="sapCpWidgetContent sapCpWidgetContentLeft sapCRLWidgetContent sapCRLWidgetContentLeft"
                    style={{ width: "20%" }}><label id="__label57" class="sapCpLabel" for="__input31">Form Name:</label></div>
                <div class="sapCpWidgetContent sapCpWidgetContentRight sapCRLWidgetContent sapCRLWidgetContentRight"
                    style={{ "padding-left": "20%" }}><input id="__input31" class="sapCpInput" type="text"
                        value="Form Submit: Chlorhexidine Demo Request - US" maxlength="255" /></div>
                <div class="sapCpWidgetFixContent sapCRLWidgetFixContent"></div>
            </div>
            <div id="application-MarketingContent-manage-component---ObjectView--DesignView--ContentPage-0L-23W"
                data-sap-cp-key="6B640EBC657EC82EF7A1D689001A9457CD672734"
                class="sapCpWidget sapCRLWidget sapCpButtonWidget" data-sap-cp-follow-up-action="02"
                data-sap-cp-wprogres-enabled="false">
                <button id="__button269" className="btn text-white"
                        type="button">Submit</button><span id="__text267"
                        class="sapCpText sapCpButtonWidgetExtraText sapCpMissingMandatoryFieldText sapCpMissingMandatoryFieldLabel">Fill
                        in all fields correctly.</span><span id="__text268"
                        class="sapCpText sapCpButtonWidgetExtraText sapCpErrorMessageText">A technical error
                        occurred.</span><span id="__text269"
                        class="sapCpText sapCpButtonWidgetExtraText sapCpSuccessMessageText sapCpSuccessMessageLabel">Thank
                        you for your submission.</span><a
                        id="__link75-application-MarketingContent-manage-component---ObjectView--DesignView--ContentPage-0L-23W-0"
                        class="sapCpLink sapCpButtonWidgetExtraText sapCpButtonWidgetDownloadLink" target="_blank"
                        data-sap-cp-download-key="2736C209DA9F5A17F87EC3A3CB1EFFCB1A4D905D">Chlorhexidine Protected
                        Catheters Overview Brochure</a><a
                        id="__link75-application-MarketingContent-manage-component---ObjectView--DesignView--ContentPage-0L-23W-1"
                        class="sapCpLink sapCpButtonWidgetExtraText sapCpButtonWidgetDownloadLink" target="_blank"
                        data-sap-cp-download-key="637373E8DBB8D5972496A2F979E9486E4D027754">CVC Cost Savings
                        Brochure</a><a
                        id="__link75-application-MarketingContent-manage-component---ObjectView--DesignView--ContentPage-0L-23W-2"
                        class="sapCpLink sapCpButtonWidgetExtraText sapCpButtonWidgetDownloadLink" target="_blank"
                        data-sap-cp-download-key="8EB710778AB52F97A7148D06E47A831CA2242536">Hemodialysis Brochure</a><a
                        id="__link75-application-MarketingContent-manage-component---ObjectView--DesignView--ContentPage-0L-23W-3"
                        class="sapCpLink sapCpButtonWidgetExtraText sapCpButtonWidgetDownloadLink" target="_blank"
                        data-sap-cp-download-key="6D518272755D963602F479270E6964606B296B94">Midline Brochure </a><a
                        id="__link75-application-MarketingContent-manage-component---ObjectView--DesignView--ContentPage-0L-23W-4"
                        class="sapCpLink sapCpButtonWidgetExtraText sapCpButtonWidgetDownloadLink" target="_blank"
                        data-sap-cp-download-key="543EF57978B8828001BA85D5780EA2E29F49B2B6">PICC Brochure</a><a
                        id="__link75-application-MarketingContent-manage-component---ObjectView--DesignView--ContentPage-0L-23W-5"
                        class="sapCpLink sapCpButtonWidgetExtraText sapCpButtonWidgetDownloadLink" target="_blank"
                        data-sap-cp-download-key="014A39717D84007BACFF1B5D43908A3B162618D1">JACC Brochure</a><a
                        id="__link75-application-MarketingContent-manage-component---ObjectView--DesignView--ContentPage-0L-23W-6"
                        class="sapCpLink sapCpButtonWidgetExtraText sapCpButtonWidgetDownloadLink" target="_blank"
                        data-sap-cp-download-key="0AD9C8B730014BC3F3FA549A3FB651FEF4F175B3">Hospital-Onset Bacteremia
                        and Fungemia (HOB)</a>
            </div>
        </div>
    </form>
      </div>
    </div>
  );
}

export default Form;